import DepartmentsDataTable from "../../../components/dataTable/tables/DepartmentsDataTable";

function DepartmentsPageView() {
    return <DepartmentsDataTable />
}

export default DepartmentsPageView;